import body from './children-body.json';
import feelings from './children-feelings.json';
import healthProblems from './children-healthProblems.json';
import helpfulPeople from './children-helpfulPeople.json';
import illnessesInjuries from './children-illnessesInjuries.json';
import pubertyGrowth from './children-pubertyGrowth.json';
import questionsAnswers from './children-questionsAnswers.json';
import relaxUnwindCenter from './children-relaxUnwindCenter.json';
import stayHealthy from './children-stayHealthy.json';
import staySafe from './children-staySafe.json';

export const children = { body, feelings, healthProblems, helpfulPeople, illnessesInjuries, pubertyGrowth, questionsAnswers, relaxUnwindCenter, stayHealthy, staySafe };
